import { useTranslation } from 'react-i18next'
import { ControllerRenderProps, FieldValues, UseFormStateReturn } from 'react-hook-form'
import Select from 'react-select'
import { FC } from 'react'
import clsx from 'clsx'

type IProps = {
  field: ControllerRenderProps<any, any>
  formState: UseFormStateReturn<FieldValues>
  lableTitle: string
  options: { label: string; value: string }[]
  placeholderTitle?: string
  classes?: string
  isDisabled?: boolean
}

const SelectField: FC<IProps> = ({
  field,
  options,
  formState,
  lableTitle,
  placeholderTitle,
  classes,
  isDisabled,
  ...props
}) => {
  const { t } = useTranslation()
  const { name, onChange, value } = field
  const { errors } = formState

  const customTheme = (theme: any) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#93c5fd',
      primary25: '#dbeafe',
      primary50: '#bfdbfe',
      gray300: '#d1d5db',
      gray500: '#6b7280',
    },
  })

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      '&:hover': {
        borderColor: 'none',
        color: 'none',
      },
      backgroundColor: state.hasValue && '#ffffff',
      borderRadius: '0.5rem',
      fontSize: '0.875rem',
      border: errors[name ?? '']?.message
        ? '2px solid rgb(252 165 165)'
        : state.isFocused
        ? '2px solid #93c5fd'
        : '2px solid #e5e7eb',
      boxShadow: errors[name ?? '']?.message
        ? '0px 0px 0px 0.25rem rgb(248 113 113 / 20%)'
        : state.isFocused && '0px 0px 0px 0.25rem rgb(147 197 253 / 20%)',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#6b7280',
    }),
    // container: (base: any) => ({
    //   ...base,
    //   display: 'inline-block',
    //   width: '20px',
    // }),
    valueContainer: (base: any) => ({
      ...base,
      minHeight: '36px',
    }),
  }

  return (
    <div className={clsx(classes, 'relative w-full h-full flex flex-col')}>
      <label className='text-sm mr-3 mb-1.5' htmlFor={''}>
        {lableTitle}
      </label>
      <Select
        isDisabled={isDisabled}
        placeholder={<div style={{ color: '#d1d5db' }}>{placeholderTitle}</div>}
        options={options}
        onChange={(option) => onChange(option?.value)}
        value={options.find((c) => c.value === value)}
        theme={customTheme}
        styles={customStyles}
        {...props}
      />
      {errors[name ?? '']?.message ? (
        <p className='absolute bottom-8 text-xs mr-3 mt-2 text-red-400 bg-white px-1 rounded-lg'>
          {t(`${errors[name ?? ' ']?.message}`)}
        </p>
      ) : null}
    </div>
  )
}

export default SelectField
